// src/pages/Contact.jsx
import React from "react";

const contactPoints = [
  {
    title: "Phone",
    items: [
      { label: "+91 9152949738", href: "tel:+919152949738", copy: "+91 9152949738" },
      { label: "+91 9152949738", href: "tel:+919152949738", copy: "+91 9152949738" },
    ],
    accent: "from-fuchsia-500 to-pink-500",
    icon: (
      <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M2.25 6.75c0 7.456 6.044 13.5 13.5 13.5a2.25 2.25 0 0 0 2.25-2.25v-1.39a1.5 1.5 0 0 0-1.05-1.43l-2.63-.88a1.5 1.5 0 0 0-1.83.74l-.35.7a10.5 10.5 0 0 1-4.12-4.12l.7-.35a1.5 1.5 0 0 0 .74-1.83l-.88-2.63A1.5 1.5 0 0 0 7.89 4.5H6.5A2.25 2.25 0 0 0 4.25 6.75z"/>
      </svg>
    ),
  },
  {
    title: "Email",
    items: [{ label: "og.constructionsolution@gmail.com", href: "mailto:og.constructionsolution@gmail.com", copy: "og.constructionsolution@gmail.com" }],
    accent: "from-cyan-500 to-sky-500",
    icon: (
      <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M3 7.5 12 13l9-5.5M4.5 6h15A1.5 1.5 0 0 1 21 7.5v9A1.5 1.5 0 0 1 19.5 18h-15A1.5 1.5 0 0 1 3 16.5v-9A1.5 1.5 0 0 1 4.5 6z"/>
      </svg>
    ),
  },
  {
    title: "Websites",
    items: [
      { label: "www.ogcs.co.in", href: "https://www.ogcs.co.in", copy: "https://www.ogcs.co.in" },
      { label: "buildpro.ogcs.co.in", href: "https://buildpro.ogcs.co.in/", copy: "https://buildpro.ogcs.co.in/" },
    ],
    accent: "from-amber-500 to-orange-500",
    icon: (
      <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M12 3a9 9 0 1 0 9 9M12 3c2.5 2.5 4 5.5 4 9s-1.5 6.5-4 9M12 3c-2.5 2.5-4 5.5-4 9s1.5 6.5 4 9M3 12h18"/>
      </svg>
    ),
  },
];

const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    // Replace with your toast if available
    alert("Copied to clipboard!");
  } catch {
    alert("Copy failed. Please copy manually.");
  }
};

const Contact = () => {
  return (
    <section className="relative overflow-hidden">
      {/* Multicolor animated background */}
      <div className="pointer-events-none absolute inset-0 -z-20">
        <div className="absolute inset-0 bg-[radial-gradient(80%_60%_at_20%_10%,rgba(255,0,128,0.18),transparent_60%),radial-gradient(70%_50%_at_80%_0%,rgba(56,189,248,0.18),transparent_60%),radial-gradient(60%_60%_at_50%_100%,rgba(250,204,21,0.18),transparent_60%)]" />
        <div className="absolute -inset-40 animate-pulse-slow rounded-full bg-gradient-to-br from-fuchsia-400/40 via-cyan-300/30 to-amber-300/30 blur-3xl" />
      </div>

      {/* Soft gradient overlay */}
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-white/70 via-white/60 to-white/80" />

      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        {/* Top badge */}
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/80 px-3 py-1 text-xs font-semibold text-gray-700 ring-1 ring-black/5 backdrop-blur">
            <span className="inline-block h-2 w-2 animate-ping rounded-full bg-emerald-500" />
            We respond quickly
          </span>
          <h1 className="mt-4 bg-gradient-to-r from-fuchsia-600 via-sky-600 to-amber-600 bg-clip-text text-3xl font-extrabold tracking-tight text-transparent sm:text-5xl">
            Connect with GrowMax-OGCS
          </h1>
          <p className="mx-auto mt-3 max-w-2xl text-sm text-gray-600 sm:text-base">
            Bulk enquiries, partnerships, or support—our team is just a call or click away.
          </p>
        </div>

        {/* Cards */}
        <div className="mt-16 grid gap-10 sm:grid-cols-2 lg:grid-cols-3">
          {contactPoints.map((block) => (
            <div
              key={block.title}
              className="group relative rounded-2xl p-[2px] transition-transform duration-300 hover:-translate-y-0.5"
            >
              {/* Gradient border */}
              <div className={`absolute inset-0 rounded-2xl bg-gradient-to-br ${block.accent} opacity-90 blur-[2px]`} />
              <div className="relative z-10 h-full rounded-2xl bg-white/90 p-6 shadow-xl ring-1 ring-black/5 backdrop-blur">
                <div className="flex items-center gap-3">
                  <div className={`rounded-xl bg-gradient-to-br ${block.accent} p-3 text-white shadow-md`}>
                    {block.icon}
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900">{block.title}</h3>
                </div>

                <ul className="mt-5 space-y-3">
                  {block.items.map((item) => (
                    <li key={item.label} className="flex items-center justify-between gap-3">
                      <a
                        href={item.href}
                        target={item.href.startsWith("http") ? "_blank" : undefined}
                        rel={item.href.startsWith("http") ? "noopener noreferrer" : undefined}
                        className="group/link flex-1 truncate text-sm font-medium text-gray-800 transition hover:text-gray-900"
                        title={item.label}
                      >
                        <span className="rounded bg-gradient-to-r from-gray-50 via-white to-gray-50 px-2 py-1 shadow-sm ring-1 ring-gray-200">
                          {item.label}
                        </span>
                        <span className="ml-1 inline-block opacity-0 transition duration-200 group-hover/link:opacity-100">
                          ↗
                        </span>
                      </a>
                      <button
                        onClick={() => copyToClipboard(item.copy)}
                        className="rounded-lg bg-gradient-to-r from-gray-100 to-white px-2.5 py-1 text-xs font-semibold text-gray-700 shadow-sm ring-1 ring-gray-200 transition hover:scale-[1.03] hover:ring-gray-300"
                      >
                        Copy
                      </button>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Glow on hover */}
              <div className={`pointer-events-none absolute -inset-2 -z-10 rounded-3xl opacity-0 transition duration-300 group-hover:opacity-100 bg-gradient-to-br ${block.accent} blur-2xl`} />
            </div>
          ))}

          {/* Address / Hours card (wide) */}
          <div className="group relative sm:col-span-2 lg:col-span-2 rounded-2xl p-[2px] transition-transform duration-300 hover:-translate-y-0.5">
            <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-emerald-500 to-lime-500 opacity-90 blur-[2px]" />
            <div className="relative z-10 h-full rounded-2xl bg-white/90 p-6 shadow-xl ring-1 ring-black/5 backdrop-blur">
              <div className="flex items-center gap-3">
                <div className="rounded-xl bg-gradient-to-br from-emerald-500 to-lime-500 p-3 text-white shadow-md">
                  <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <path d="M12 21s7-5.686 7-11A7 7 0 0 0 5 10c0 5.314 7 11 7 11z" />
                    <circle cx="12" cy="10" r="2.5" />
                  </svg>
                </div>
                <h3 className="text-lg font-semibold text-gray-900">Address & Hours</h3>
              </div>

              <div className="mt-5 grid gap-6 sm:grid-cols-2">
                <div className="space-y-1 text-sm">
                  <p className="font-semibold text-gray-900">Head Office</p>
                  <p className="text-gray-700">New Panvel, Navi Mumbai, Maharashtra, India</p>
                </div>
                <div className="space-y-1 text-sm">
                  <p className="font-semibold text-gray-900">Business Hours</p>
                  <p className="text-gray-700">Mon–Sat: 10:00 AM – 7:00 PM IST</p>
                  <p className="text-gray-700">Sunday: Closed</p>
                </div>
              </div>

              {/* Decorative stripe */}
              <div className="mt-6 h-1 w-full rounded-full bg-gradient-to-r from-fuchsia-500 via-sky-500 to-amber-500" />
            </div>
            <div className="pointer-events-none absolute -inset-2 -z-10 rounded-3xl opacity-0 transition duration-300 group-hover:opacity-100 bg-gradient-to-br from-emerald-500 to-lime-500 blur-2xl" />
          </div>
        </div>

        {/* CTA */}
        <div className="mx-auto mt-12 flex max-w-2xl flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="mailto:growmax@ogcs.co.in?subject=Enquiry%20from%20Website"
            className="inline-flex items-center justify-center rounded-xl bg-gradient-to-r from-fuchsia-600 via-rose-500 to-orange-500 px-5 py-3 text-sm font-semibold text-white shadow-lg shadow-rose-500/20 transition hover:scale-[1.02] focus:outline-none focus:ring-2 focus:ring-rose-400 focus:ring-offset-2"
          >
            Email Us
          </a>
          <a
            href="tel:+919152949738"
            className="inline-flex items-center justify-center rounded-xl bg-gradient-to-r from-sky-600 to-cyan-500 px-5 py-3 text-sm font-semibold text-white shadow-lg shadow-sky-500/20 transition hover:scale-[1.02] focus:outline-none focus:ring-2 focus:ring-sky-400 focus:ring-offset-2"
          >
            Call Now
          </a>
          <a
            href="https://buildpro.ogcs.co.in/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center rounded-xl bg-gradient-to-r from-amber-500 to-orange-500 px-5 py-3 text-sm font-semibold text-white shadow-lg shadow-amber-500/20 transition hover:scale-[1.02] focus:outline-none focus:ring-2 focus:ring-amber-400 focus:ring-offset-2"
          >
            Visit BuildPro
          </a>
        </div>
      </div>

      {/* Keyframe helper: add to globals if needed */}
      <style>
        {`
          @keyframes pulse-slow {
            0%, 100% { transform: scale(1); opacity: 0.7; }
            50% { transform: scale(1.06); opacity: 1; }
          }
          .animate-pulse-slow {
            animation: pulse-slow 8s ease-in-out infinite;
          }
        `}
      </style>
    </section>
  );
};

export default Contact;
